export default __webpack_public_path__ + "8f6594a03a4a49fdf3edd8c40f36c40d.jpg";